import FilePicker, { FilePickerProps } from './FilePicker';

export type { FilePickerProps };
export default FilePicker;